import { render, staticRenderFns } from "./timer.vue?vue&type=template&id=3c5c16c5&"
import script from "./timer.vue?vue&type=script&lang=js&"
export * from "./timer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c5c16c5')) {
      api.createRecord('3c5c16c5', component.options)
    } else {
      api.reload('3c5c16c5', component.options)
    }
    module.hot.accept("./timer.vue?vue&type=template&id=3c5c16c5&", function () {
      api.rerender('3c5c16c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/timer.vue"
export default component.exports